import AOS from 'aos';
import 'aos/dist/aos.css';

AOS
AOS.init({
  duration: 1000,
  offset: 100,
  once: true
});

// window.addEventListener('load', AOS.refresh);

// document.addEventListener('scroll', () => {
//   AOS.refreshHard(); // 強制再計算
// });
